module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQRJREFUeNpiYACCjo6O/xACCAACCMRYzwADQE4CQAChiADZ++FqwbJAABBAjHBTGBgcGXACmDIBIPUeIIAYkPSgWAfE/YxQCUEgvg+VU4SyAzF0Ien+DxBAMDscgNR+qPiGioqKQJiKfpijkXUhvIbd2PUsQLoRyHiP5BAGoLEgBwbg9DDIaCYcEiA3OLKgCYJcXQ/EF4BGLwAIMEYkiflACqTjABAvBOIHUCkFII4HYpDGCUBNheBwRvJ/IsgkBjwA6hSQBY5MxGqC+h6kJhGkhwUmAI1d9DhjwBJsYC+wIJn2ARrhMICLDQqgDSwMRAIk/4EDiAVbusMCNgDxRKAGeCwAALj8dhfePqgbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/wzs.png
// module id = l8dc
// module chunks = 1